"use strict";

require("core-js/modules/es6.array.for-each");

require("core-js/modules/es6.regexp.split");

require("core-js/modules/es6.string.trim");

exports.__esModule = true;
exports.adressValidator = exports.addressParser = exports.addressBuilder = void 0;

var addressBuilder = function addressBuilder(province, municipality, baranggay) {
  var delimiter = ", ";
  var address = '';

  if (baranggay && baranggay.value) {
    address = address + baranggay.value;
  }

  address = address + delimiter;

  if (municipality && municipality.value) {
    address = address + municipality.value;
  }

  address = address + delimiter;

  if (province && province.value) {
    address = address + province.value;
  } // if (province && province.value) {
  //     address = address + province.value;
  // }
  // address = address + delimiter;
  // if (municipality && municipality.value) {
  //     address = address + municipality.value;
  // }
  // address = address + delimiter;
  // if (baranggay && baranggay.value) {
  //     address = address + baranggay.value;
  // }


  return address;
};

exports.addressBuilder = addressBuilder;

var addressObjBuilder = function addressObjBuilder(name) {
  if (name && name.trim()) {
    return {
      id: name,
      value: name
    };
  }

  return "";
};

var addressParser = function addressParser(cityAddress) {
  if (cityAddress && cityAddress.trim()) {
    var str = cityAddress;
    var res = str.split(", ");
    return {
      baranggay: addressObjBuilder(res[0]),
      municipality: addressObjBuilder(res[1]),
      province: addressObjBuilder(res[2])
    }; // return { province: addressObjBuilder(res[0]), municipality: addressObjBuilder(res[1]), baranggay: addressObjBuilder(res[2]) };
  } else {
    return {
      baranggay: '',
      municipality: '',
      province: ''
    }; // return { province: '', municipality: '', baranggay: '' };
  }
};

exports.addressParser = addressParser;

var adressValidator = function adressValidator(cityAddress) {
  var isValid = false;
  var errors = {
    province: 'Province is required',
    municipality: 'Municipality is required',
    barangay: 'Barangay is required'
  };

  if (cityAddress && cityAddress !== null && cityAddress !== undefined && cityAddress.trim()) {
    var str = cityAddress;
    var res = str.split(", ");
    res.forEach(function (element, index) {
      if (index === 0 && element !== "") {
        // errors.province = "";
        errors.barangay = "";
      }

      if (index === 1 && element !== "") {
        errors.municipality = "";
      }

      if (index === 2 && element !== "") {
        errors.province = ""; // errors.barangay = "";
      }
    });
  }

  if (errors.province === "" && errors.municipality === "" && errors.barangay === "") {
    isValid = true;
  }

  return {
    errors: errors,
    isValid: isValid
  };
};

exports.adressValidator = adressValidator;